var _circle, _rect, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    fill: "url(#paint0_linear_1011_19248)",
    stroke: "#424242"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 25,
    width: 32,
    height: 34,
    fill: "url(#paint1_linear_1011_19248)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 50.5,
    r: 7.5,
    fill: "#17181D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3335 61.1666H34.3335C33.743 61.1708 33.1558 61.0791 32.5946 60.8952C32.1173 60.7301 31.7244 60.3834 31.5014 59.9303C31.2783 59.4772 31.2431 58.9543 31.4034 58.4754C31.5637 57.9965 31.9066 57.6002 32.3574 57.3726C32.8083 57.1451 33.3308 57.1047 33.8113 57.2602C33.9804 57.3121 34.1567 57.3367 34.3335 57.3333H57.3335C57.8417 57.3327 58.3289 57.1306 58.6882 56.7713C59.0476 56.412 59.2497 55.9248 59.2502 55.4166V28.5833C59.2497 28.0751 59.0476 27.5879 58.6882 27.2285C58.3289 26.8692 57.8417 26.6671 57.3335 26.6666H34.3335C33.8253 26.6671 33.3381 26.8692 32.9788 27.2285C32.6194 27.5879 32.4173 28.0751 32.4168 28.5833V42.057C32.4168 42.5653 32.2149 43.0529 31.8555 43.4123C31.496 43.7717 31.0085 43.9737 30.5002 43.9737C29.9918 43.9737 29.5043 43.7717 29.1449 43.4123C28.7854 43.0529 28.5835 42.5653 28.5835 42.057V28.5833C28.5852 27.0588 29.1915 25.5972 30.2695 24.5192C31.3474 23.4413 32.809 22.8349 34.3335 22.8333H57.3335C58.858 22.8349 60.3195 23.4413 61.3975 24.5192C62.4755 25.5972 63.0818 27.0588 63.0835 28.5833V55.4166C63.0818 56.9411 62.4755 58.4026 61.3975 59.4806C60.3195 60.5586 58.858 61.1649 57.3335 61.1666Z",
    fill: "url(#paint2_linear_1011_19248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4582 61.1666C29.3732 61.1666 27.3351 60.5483 25.6015 59.39C23.868 58.2317 22.5168 56.5853 21.7189 54.659C20.9211 52.7328 20.7123 50.6132 21.1191 48.5683C21.5258 46.5235 22.5298 44.6451 24.0041 43.1708C25.4784 41.6966 27.3567 40.6926 29.4016 40.2858C31.4465 39.8791 33.5661 40.0878 35.4923 40.8857C37.4185 41.6836 39.0649 43.0347 40.2233 44.7683C41.3816 46.5019 41.9998 48.54 41.9998 50.6249C41.9965 53.4197 40.8848 56.0991 38.9086 58.0753C36.9324 60.0516 34.253 61.1633 31.4582 61.1666ZM31.4582 43.9166C30.1314 43.9166 28.8344 44.31 27.7312 45.0471C26.628 45.7843 25.7682 46.832 25.2605 48.0578C24.7527 49.2835 24.6199 50.6324 24.8787 51.9337C25.1376 53.2349 25.7765 54.4303 26.7147 55.3684C27.6528 56.3066 28.8482 56.9455 30.1494 57.2044C31.4507 57.4632 32.7996 57.3304 34.0253 56.8226C35.2511 56.3149 36.2988 55.4551 37.036 54.3519C37.7731 53.2487 38.1665 51.9517 38.1665 50.6249C38.1644 48.8464 37.4569 47.1414 36.1993 45.8838C34.9417 44.6262 33.2367 43.9187 31.4582 43.9166Z",
    fill: "url(#paint3_linear_1011_19248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1858 55.9914C32.8295 55.9917 32.4802 55.8928 32.177 55.7057C31.8738 55.5185 31.6288 55.2506 31.4694 54.932L29.7437 51.4823C29.6107 51.2161 29.5415 50.9226 29.5415 50.6251V47.1755C29.5415 46.6671 29.7434 46.1796 30.1029 45.8202C30.4623 45.4607 30.9498 45.2588 31.4582 45.2588C31.9665 45.2588 32.454 45.4607 32.8135 45.8202C33.1729 46.1796 33.3748 46.6671 33.3748 47.1755V50.1721L34.8984 53.2174C35.0446 53.5095 35.1136 53.8341 35.099 54.1604C35.0845 54.4867 34.9868 54.8038 34.8152 55.0817C34.6436 55.3596 34.4039 55.589 34.1187 55.7482C33.8335 55.9074 33.5124 55.9911 33.1858 55.9914Z",
    fill: "url(#paint4_linear_1011_19248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4168 36.2501H36.2502C35.7418 36.2501 35.2543 36.0481 34.8949 35.6887C34.5354 35.3293 34.3335 34.8417 34.3335 34.3334C34.3335 33.8251 34.5354 33.3376 34.8949 32.9781C35.2543 32.6187 35.7418 32.4167 36.2502 32.4167H55.4168C55.9252 32.4167 56.4127 32.6187 56.7721 32.9781C57.1316 33.3376 57.3335 33.8251 57.3335 34.3334C57.3335 34.8417 57.1316 35.3293 56.7721 35.6887C56.4127 36.0481 55.9252 36.2501 55.4168 36.2501Z",
    fill: "#181A1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4167 42.9583H43.9167C43.4083 42.9583 42.9208 42.7564 42.5614 42.397C42.2019 42.0375 42 41.55 42 41.0417C42 40.5333 42.2019 40.0458 42.5614 39.6864C42.9208 39.3269 43.4083 39.125 43.9167 39.125H55.4167C55.925 39.125 56.4125 39.3269 56.772 39.6864C57.1314 40.0458 57.3333 40.5333 57.3333 41.0417C57.3333 41.55 57.1314 42.0375 56.772 42.397C56.4125 42.7564 55.925 42.9583 55.4167 42.9583Z",
    fill: "#181A1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4165 49.6666H48.7082C48.1998 49.6666 47.7123 49.4647 47.3529 49.1052C46.9934 48.7458 46.7915 48.2583 46.7915 47.7499C46.7915 47.2416 46.9934 46.7541 47.3529 46.3946C47.7123 46.0352 48.1998 45.8333 48.7082 45.8333H55.4165C55.9248 45.8333 56.4123 46.0352 56.7718 46.3946C57.1312 46.7541 57.3332 47.2416 57.3332 47.7499C57.3332 48.2583 57.1312 48.7458 56.7718 49.1052C56.4123 49.4647 55.9248 49.6666 55.4165 49.6666Z",
    fill: "#181A1E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19248",
    x1: 42,
    y1: 84,
    x2: 42,
    y2: -4.32905e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1011_19248",
    x1: 30,
    y1: 42.2464,
    x2: 62,
    y2: 42.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1011_19248",
    x1: 28.5835,
    y1: 42.2778,
    x2: 63.0835,
    y2: 42.2778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1011_19248",
    x1: 20.9165,
    y1: 50.7777,
    x2: 41.9998,
    y2: 50.7777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1011_19248",
    x1: 29.5415,
    y1: 50.7028,
    x2: 35.101,
    y2: 50.7028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShare);
export default __webpack_public_path__ + "static/media/no-share.16834646bdb3f3d6d87d255246ece9cb.svg";
export { ForwardRef as ReactComponent };